<div
  class="pgb-style-outer-container"
  *ngrxLet="vm$ as vm"
  [ngClass]="vm.outerContainerClasses ? [vm.outerContainerClasses] : []"
>
  <fieldset class="m-0">
    <legend>{{ vm.title }}</legend>
    <div
      class="d-flex d-flex--summary-container"
      [class.vertical-view]="vm.layout === 'vertical'"
      [orderformBreakpoint]="vm.layout === 'horizontal' ? { '700': 'vertical-view', '800': 'size-1-2' } : {}"
    >
      <div class="container-product-list">
        <orderform-product-list-mini
          (countProducts)="onCountProductsChange($event)"
          [expressCheckoutMode]="expressCheckoutMode"
        ></orderform-product-list-mini>
      </div>
      <div
        class="container-summary-button pgb-style-inner-container"
        [ngClass]="vm.innerContainerClasses ? [vm.innerContainerClasses] : []"
      >
        <orderform-order-summary></orderform-order-summary>
        <ng-content></ng-content>
      </div>
    </div>
  </fieldset>
</div>
